import { Hash, Type, CircleDot, ListChecks, CalendarDays, ToggleLeft } from 'lucide-react';

// One lucide icon per field type — the builder's type picker and the set
// cards use the same six.
export const FIELD_TYPE_ICON = {
    number: Hash,
    text: Type,
    select: CircleDot,
    multi: ListChecks,
    date: CalendarDays,
    yesno: ToggleLeft,
};
